import { useSelector } from 'react-redux';

export const useErrorReport = () =>
  useSelector(state => {
    if (state.error.reportQueue.length === 0) return undefined;
    return state.error.reportQueue[0];
  });
